export const syncEventsAssign = (message, reducers, data, connection) => {
  const { eventsDispatch } = reducers;
  eventsDispatch({ type: 'EVENTS_ASSIGN', payload: message.payload });
}